import client from "../client";
import {DashboardResource} from "client/resources/dashboardResource";

export default class DashboardRepository {
    private rootUri = "/api/dashboard";

    get(): Promise<DashboardResource> {
        return client.get(`${this.rootUri}`);
    }
}